import type {
  EventResultDTO,
  WebViewBootstrapResultDTO,
} from '@nora-monorepo/nora-api-client';

export enum NoraWebViewEventPattern {
  WEBVIEW_INITIALIZED = 'nora.webview.initialized',
  WEBVIEW_BOOTSTRAP_COMPLETED = 'nora.webview.bootstrap.completed',
  WEBVIEW_UPDATE_MAP_SOURCES = 'nora.webview.update.map.sources',
  WEBVIEW_UPDATE_MAP_LOCATION = 'nora.webview.update.map.location',
  WEBVIEW_LOAD_MAP = 'nora.webview.load.map',

  BOOTSTRAP_WEBVIEW_CLEAN = 'nora.webview.bootstrap.clean',
  BOOTSTRAP_WEBVIEW_PERSISTED = 'nora.webview.bootstrap.persisted',

  CONNECTIVITY_CHANGED = 'nora.webview.connectivity.changed',

  TRACK_API_STREAM_POSITION_RESPONSE = 'nora.webview.track.api.stream.position.response',

  SSE_STREAM_EVENT = 'nora.webview.sse.stream.event',

  REQUEST = 'nora.webview.request',
  RESPONSE = 'nora.webview.response',

  UPDATE_PERSISTED_STATE = 'nora.webview.update.persisted.state',

  OPEN_FILE = 'nora.webview.open.file',
}

export interface NoraWebViewEvent {
  pattern: NoraWebViewEventPattern;
  data?: Record<string, unknown>;
}

export interface NoraWebViewBootstrapCleanEvent {
  data: WebViewBootstrapResultDTO | string;
}

export interface NoraWebViewBootstrapPersistedEvent {
  data: Record<string, string>;
}

export interface NoraWebViewConnectivityChangedEvent {
  data: { online: boolean };
}

export interface NoraWebViewBootstrapCompletedEvent {
  data?: Record<string, never>;
}

export interface NoraWebViewTrackApiStreamPositionResponseEvent {
  data: Record<string, unknown>;
}

export interface NoraWebViewSseStreamEvent {
  data: EventResultDTO;
}

export interface NoraWebViewRequestEvent {
  data: {
    method: string;
    url: string;
    data: unknown;
  };
}

/**
 * Represents a request response in the Webview.
 */
export interface NoraWebViewResponse {
  method: string;
  url: string;
  data: string;
  headers?: Record<string, string>;
  status?: number;
  statusText?: string;
}

export interface NoraWebViewResponseEvent {
  data: NoraWebViewResponse;
}

export interface NoraWebViewUpdatePersistedStateEvent {
  data: Record<string, string>;
}

export interface NoraWebViewMapSource {
  mapSource: string;
  id: string;
  name: string;
}

export interface NoraWebViewUpdateMapSources {
  data: { mapSources: NoraWebViewMapSource[] };
}

export interface NoraWebViewUpdateMapLocationEvent {
  data: { latitude: number; longitude: number; zoom?: number; producerId?: string };
}

export interface NoraWebViewLoadMapEvent {
  data: { operationId?: string };
}

export interface NoraWebViewOpenFileEvent {
  data: {
    domain: string;
    domainId: string;
    id: string;
    path: string;
  };
}
